import React from 'react';
import { useTranslation } from '../i18n';

interface ProgressBarProps {
  progress: number;
  isProcessing: boolean;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ progress, isProcessing }) => {
  const { t } = useTranslation();
  const displayProgress = Math.round(progress);
  const displayText = isProcessing
    ? t('statusProcessing')
    : `${t('statusUploadingProgress')} ${displayProgress}%`;

  return (
    <div className="mt-6 w-full">
      <div className="relative h-3 w-full bg-slate-700 rounded-full overflow-hidden">
        <div
          className={`absolute top-0 left-0 h-full bg-indigo-500 rounded-full transition-all duration-300 ease-out ${isProcessing ? 'animate-pulse' : ''}`}
          style={{ width: `${isProcessing ? 100 : displayProgress}%` }}
        ></div>
      </div>
      <p className="text-center text-sm text-slate-400 mt-2 font-medium">
        {displayText}
      </p>
    </div>
  );
};

export default ProgressBar;
